// 科研数据 - 请根据实际情况填充
const researchData = [
  {
    year: "2026.01",
    month: "01",
    title:
      "Leveraging Distributional Symmetry in Credit Card Fraud Detection via Conditional Tabular GAN Augmentation and LightGBM",
    institution: "Symmetry（SCI 二区，二作）",
    supervisor: null,
    description:
      "针对信用卡欺诈检测中的极端类别不平衡问题，提出基于 CTGAN 的数据增强与 LightGBM 的混合方法：通过高质量生成少数类样本，并引入严格的分布验证机制，有效提升召回率与精度。",
    tech: ["CTGAN", "LightGBM"],
    image: null,
    paper: "https://www.mdpi.com/2073-8994/18/2/224",
    arxiv: null,
    github: null,
  },
  {
    year: "2025.10",
    month: "10",
    title:
      "C-FLORA: A Modular Federated Adaptation Framework for Communication-Efficient, Continual, and Robust Edge Learning",
    institution: "ICIC（CCF-C）在投；专利在申",
    supervisor: "陈哲毅",
    description:
      "针对边缘联邦学习中的通信受限、数据异质、任务漂移致遗忘与拜占庭干扰四大核心问题，提出集成四大互补模块的模块化联邦适配框架，实现模块解耦；在 CIFAR-100 严苛实验环境下，相较 FedAvg 显著提升准确率与鲁棒性，并降低通信负载、加快收敛，同时有效缓解灾难性遗忘与提升加密适配性。",
    tech: ["Federated Learning", "Continual Learning", "Mixture-of-Experts"],
    image: null,
    paper: null,
    arxiv: null,
    github: null,
  },
  {
    year: "2025.08",
    month: "08",
    title: "基于大语言模型的NAO机器人具身交互系统",
    institution: "论文还在撰写中",
    supervisor: "黄晗静",
    description:
      "以 Python 为核心开发语言，调用 Naoqi SDK 构建通信桥梁，设计并实现心理咨询微调大语言模型与机器人底层运动控制的接口映射方案。最终实现自然语言指令到机器人问答交互与肢体动作执行的端到端全链路控制，使机器人具备对用户自然语言的精准理解与多模态响应能力。",
    tech: ["LLM", "NAO"],
    image: null,
    paper: null,
    arxiv: null,
    github: null,
  },
  {
    year: "2025.04",
    month: "04",
    title: "多无人机辅助车联网下基于联邦深度强化学习的资源分配与协作卸载",
    institution: "国家级大学生创新训练计划",
    supervisor: "陈哲毅",
    description:
      "提出并实现面向多无人机辅助车联网的资源分配与协作卸载方法（RACOMU），结合凸优化与联邦深度强化学习，解决动态环境下的任务分配、功率控制与隐私保护问题。",
    tech: ["强化学习", "资源分配与协作卸载"],
    image: null,
    paper: null,
    arxiv: null,
    github: null,
  },
  {
    year: "2025.02",
    month: "02",
    title: "强化学习文献精读与学习，每周组会",
    institution: null,
    supervisor: "傅建明",
    description:
      "围绕强化学习方向开展文献精读与系统学习，并按计划参加每周组会，完成阶段性总结与讨论。",
    tech: ["强化学习"],
    image: null,
    paper: null,
    arxiv: null,
    github: null,
  },
];

export default researchData;
